var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBase = function SvgBase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 16.866a6.368 6.368 0 0 0-7.495-1.12c-.683.365-1.508-.085-1.508-.859V5.791c0-.636.294-1.248.812-1.617A6.367 6.367 0 0 1 12 4.86a6.367 6.367 0 0 1 8.192-.687c.518.369.812.981.812 1.617v9.096c0 .774-.825 1.225-1.509.86A6.368 6.368 0 0 0 12 16.866",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.505 19.884a6.368 6.368 0 0 1 7.496 1.12 6.368 6.368 0 0 1 7.495-1.12M12 16.866V4.861"
  }))));
};
export { SvgBase as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiOWJmYTg4ZDA5YTdlNGZjNTA0NmJiMjFlNzdlMzliYmQuc3ZnIjs=";